import { UserStatusLabel, UserStatuses } from 'system/enums';

export const USER_STATUSES_LABEL: Record<UserStatuses, UserStatusLabel> = {
  [UserStatuses.ALL]: UserStatusLabel.ALL,
  [UserStatuses.ACTIVE]: UserStatusLabel.ACTIVE,
  [UserStatuses.INACTIVE]: UserStatusLabel.INACTIVE,
  [UserStatuses.BLOCKED]: UserStatusLabel.BLOCKED,
};
